import { HubConnectionState } from '@microsoft/signalr';

export const JOB_PROGRESS_EVENT = 'jobProgress';
const JOB_PROGRESS_HUB_PATH = '/hubs/job-progress';

export function buildHubUrl(apiBase: string): string {
    return new URL(JOB_PROGRESS_HUB_PATH, apiBase).toString();
}

export function isUsableConnectionState(state: HubConnectionState): boolean {
    return (
        state === HubConnectionState.Connected ||
        state === HubConnectionState.Connecting ||
        state === HubConnectionState.Reconnecting
    );
}
